(ns teamoesterreich.lebensretter-mode.status-identity
  (:require [clojure.string]
            [goog.date.DateTime]
            [reagent-material-ui.components :as mui]
            [reagent-material-ui.icons.check :refer [check]]
            [reagent-material-ui.icons.access-time :refer [access-time]]
            [reagent-material-ui.icons.warning :refer [warning]]
            [teamoesterreich.firebase.storage-provider :as storage-provider]
            [reagent.core :as r]
            [teamoesterreich.lebensretter-mode.widgets :refer [document-view specific-upload-button]]
            [teamoesterreich.store :as store]
            [teamoesterreich.user-mode.ui-helper.preview-modal :as preview-modal]
            [teamoesterreich.util.log :as log]))


(defn status-identity []

  (let [!userId (r/cursor store/app-state [:firebase-uid])
        !actual-user (r/cursor store/app-state [:actual-user])
        !user-documents (r/cursor store/app-state [:user-documents])
        !state (r/atom {:url nil :loading false :show-delete-modal false :enlarge false})
        !enlarge (r/cursor !state [:enlarge])]
    (fn []

      (let [prop-doc (first (reverse (sort :uploaded (filter (fn [d]
                                                               (and (not (:deleted d))
                                                                    (some #{(:type d)} ["identification"])
                                                                    ))
                                                             (mapv second @!user-documents)))))
            valid-doc (first (reverse (sort :uploaded (filter (fn [d]
                                                                ;(log/out " ################  filter-eh  " (:valid d) (:isTraining d) (> (* 1000 (.-seconds (:valid-until d)) (js/Date.now))))
                                                                (and (> (* 1000 (.-seconds ^js (:validTo d)) (js/Date.now)))
                                                                     (not (:rejected d))
                                                                     (not (:deleted d))
                                                                     (:isIdentity d)
                                                                     ))
                                                              (mapv second @!user-documents)))))
            doc (or valid-doc prop-doc)

            ]
        (log/out " ################  status-identity  " valid-doc (pr-str @!user-documents))
        (if doc
          (do
            (when (and (:path doc) (not (:loading @!state)))
              (storage-provider/get-download-url (:path doc)
                                                 (fn [dwn-url]
                                                   (log/out "store callback previewUri " (:path doc) dwn-url)
                                                   (swap! !state assoc :url dwn-url :path (:path doc))
                                                   (swap! !state assoc :loading true)
                                                   ))
              )

            (if valid-doc
              [:div {:class "helping-form-check-line" :style {:minHeight "110px"}}
               (log/debug "valid-doc " valid-doc)
               [preview-modal/modal (:url @!state) !enlarge]
               [:div {:class "check-line-icon"}
                [check]]
               [:div {:class "check-line-text"}
                "Ausweisdokument"
                [:br] (:name doc)]
               (when (:path doc)
                 (if (:url @!state)
                   (document-view !state (:name doc))
                   [mui/circular-progress {:style {:float "right" :maxHeight "50px"}}]
                   ))
               ]
              ;else
              [:div {:class "helping-form-check-line" :style {:minHeight "100px"}}
               [preview-modal/modal (:url @!state) !enlarge]
               [:div {:class "check-line-icon"}
                (if (:rejected prop-doc) [warning {:style {:color "darkred"}}] [access-time])]
               (if (:rejected prop-doc)
                 ;rejected
                 [:div {:class "check-line-text"}
                  "Ausweisdokument abgelehnt: "
                  [:br] (:name doc)
                  [:br]
                  [:span {:style {:color "darkred"}} (:rejectMessage prop-doc)]
                  [(specific-upload-button "identification" !state !userId "hochladen")]]

                 [:div {:class "check-line-text"}
                  "Ausweisdokument hochgeladen bitte warte auf die Validierung."
                  [:br] (:name doc)
                  [:br]
                  [:span {:style {:color "#ac740d"}} "Bitte um Geduld, die Bestätigung ist unsererseits noch ausständig."]
                  [(specific-upload-button "identification" !state !userId "hochladen")]])
               (when (:path doc)
                 (if (:url @!state)
                   (document-view !state (:name doc))
                   [mui/circular-progress {:style {:float "right" :maxHeight "50px"}}]
                   ))

               ]))
          ;else
          (when (:request-lebensretter @!actual-user)
            [:div {:class "helping-form-check-line" :style {:margin-top "20px"}}
             [:div {:class "check-line-icon"}
              [warning {:style {:color "darkred"}}]]
             [:div {:class "check-line-text"}
              "um deine Identität zu bestätigen lade bitte einen Ausweis hoch" [:br]
              [:span {:style {:color "#ac740d"}} "Bitte um Geduld, die Bestätigung unsererseits kann ein paar Tage dauern."]
              [(specific-upload-button "identification" !state !userId)]
              ]])
          )))))